'use client'

import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

interface UserData {
  month: string
  newUsers: number
  totalUsers: number
}

interface UserGrowthChartProps {
  data: UserData[]
}

export default function UserGrowthChart({ data }: UserGrowthChartProps) {
  return (
    <div className="bg-white dark:bg-charcoal-900 rounded-xl p-6 border border-charcoal-200 dark:border-charcoal-800">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-charcoal-900 dark:text-white mb-2">
          User Growth
        </h3>
        <p className="text-sm text-charcoal-600 dark:text-charcoal-400">
          New user registrations and total user count
        </p>
      </div>
      
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data}>
            <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
            <XAxis 
              dataKey="month" 
              className="text-xs"
              tick={{ fill: 'currentColor' }}
            />
            <YAxis 
              className="text-xs"
              tick={{ fill: 'currentColor' }}
            />
            <Tooltip 
              formatter={(value: number, name: string) => [
                value, 
                name === 'newUsers' ? 'New Users' : 'Total Users'
              ]}
              labelStyle={{ color: 'var(--charcoal-900)' }}
              contentStyle={{
                backgroundColor: 'var(--white)',
                border: '1px solid var(--charcoal-200)',
                borderRadius: '8px',
              }}
            />
            <Area 
              type="monotone" 
              dataKey="totalUsers" 
              stackId="1"
              stroke="#10b981" 
              fill="#10b981"
              fillOpacity={0.6}
            />
            <Area 
              type="monotone" 
              dataKey="newUsers" 
              stackId="2"
              stroke="#8b5cf6" 
              fill="#8b5cf6"
              fillOpacity={0.8}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
